module.exports = window.L = require('leaflet/dist/leaflet-src');



//////////////////
// WEBPACK FOOTER
// ./~/mapbox.js/src/leaflet.js
// module id = 357
// module chunks = 1